import gql from 'graphql-tag'

export default gql`subscription projectsUpserted($project_id: String, 
    $name: String, 
    $project_status_id: String, 
    $project_director_id: String, 
    $project_manager_id: String,
    $project_clients: String) {
  projectsUpserted(project_id: $project_id, 
                    name: $name, 
                    project_status_id: $project_status_id, 
                    project_director_id: $project_director_id, 
                    project_manager_id: $project_manager_id,
                    project_clients: $project_clients){
    project_id_prefix
    project_id
    name
    description
    project_status{
        description
    }
    project_director{
      user_id
      first_name
      last_name
    }
    project_manager{
      user_id
      first_name
      last_name
    }
    
    project_associated_disciplines{
      project_discipline_id
      description
    }
    project_activity_budgets{
      id
      project_activity_type_id
      description
      amount
    }
    project_clients{
      client{
        client_id
        name
      }
      address{
        address_id
        abode_name_no
        building_no
        street
        city
        postcode
      }
    }
    project_addresses{
      address_id
      abode_name_no
      building_no
      street
      city
      postcode
    }
  }
}`